import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism';

interface HighLighterProps {
  codeString: string;
  language: string;
}

const CodeHighLight = ({ codeString, language }: HighLighterProps) => {
  return (
    <SyntaxHighlighter
      language={language}
      wrapLines={true}
      showLineNumbers={true}
      style={dracula}
    >
      {codeString}
    </SyntaxHighlighter>
  );
};

export default CodeHighLight;
